import axios, { getEnv } from './api';

const FuncionalidadesService = {
  getFuncionalidades: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/funcionalidades`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getOptions: async (isOptimized = false) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/funcionalidades/opcoes?consulta=${isOptimized}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getCidades: async (uf) => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/cidades/${uf}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updateStatusFuncionalidade: async (idFuncionalidade, status) => {
    try {
      const res = await axios.put(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/funcionalidades/${idFuncionalidade}/${status}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  deleteFuncionalidade: async (idFuncionalidade) => {
    try {
      const res = await axios.delete(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/funcionalidades/${idFuncionalidade}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getParceiros: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/parceiros`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  addFuncionalidade: async (funcionalidade) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/funcionalidades`,
        funcionalidade
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getFuncoes: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/funcoesAPP`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getCnaes: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/cnaes`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPortes: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/empreendedores/portes`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPalavras: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/palavras`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updateFuncionalidade: async (funcionalidade) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/funcionalidades`,
        funcionalidade
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getFilteredFuncionalidades: async (mapParams, filters) => {
    try {
      const res = await axios.post(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/funcionalidades/filtrar${mapParams}`,
        filters
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getAnalytics: async (status) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/funcionalidades/quantidade/status/${status}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default FuncionalidadesService;
